/**
 * Diagnostic wrapper to count history.replaceState calls
 * This will help identify the source of the Safari SecurityError
 */

/* eslint-disable no-restricted-globals */
// Store original methods
const originalReplaceState = history.replaceState;
const originalPushState = history.pushState;

let replaceCount = 0;
let pushCount = 0;
let callLog = [];

// Wrap replaceState
history.replaceState = function(...args) {
  replaceCount++;
  const stack = new Error().stack;
  callLog.push({
    type: 'replaceState',
    count: replaceCount,
    url: args[2],
    stack: stack?.split('\n').slice(2, 6).join('\n'),
    timestamp: Date.now(),
  });
  
  if (replaceCount > 50) {
    console.error(`[DIAGNOSTIC] replaceState called ${replaceCount} times!`);
    console.error('Recent calls:', callLog.slice(-10));
  }
  
  return originalReplaceState.apply(this, args);
};

// Wrap pushState
history.pushState = function(...args) {
  pushCount++;
  callLog.push({
    type: 'pushState',
    count: pushCount,
    url: args[2],
    timestamp: Date.now(),
  });
  return originalPushState.apply(this, args);
};

// Log summary every second
setInterval(() => {
  if (replaceCount > 0 || pushCount > 0) {
    console.log(`[DIAGNOSTIC] replaceState: ${replaceCount}, pushState: ${pushCount}`);
  }
}, 1000);

// Expose diagnostic data
window.__historyDiagnostics = {
  getCounts: () => ({ replaceCount, pushCount }),
  getLog: () => callLog,
  reset: () => { replaceCount = 0; pushCount = 0; callLog = []; },
};

console.log('[DIAGNOSTIC] History API wrapped. replaceState/pushState calls will be logged.');
